<template>
    <div class="sso-registered">
        <div class="all-wrapper menu-side with-pattern">
            <div class="auth-box-w">
                <div class="logo-w">
                    <router-link :to="{ name: 'login' }"><img :alt="allTemplateDetails.name" width="100%" :src="allTemplateDetails.loginLogoImage"></router-link>
                </div>
                <h4 class="auth-header">
                    {{ t('ssoSuccessfulRegistration', 'ssoSuccessfulRegistration') }}
                    <div class="translationBox">
                        <Translation></Translation>
                    </div>
                </h4>
                <ResponseInfo></ResponseInfo>
                <form>
                <small>{{ t('ssoRegSuccessText', 'ssoRegSuccessText') }}</small>
                <div class="row mt-2">
                    <b-form-group class="mt-1 col-12">
                        <b-input-group>
                            <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                            <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('ssoLoginLinkLabel', 'ssoLoginLinkLabel') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <span class="form-control disabled-field"><router-link :to="{ name: 'login' }">{{ t('ssoLoginLink', 'ssoLoginLink') }}</router-link></span>
                        </b-input-group>
                    </b-form-group>
                </div>
                <div class="row">
                    <b-form-group class="mt-1 col-12">
                        <b-input-group>
                            <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                            <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('ssoUserEmailLabel', 'ssoUserEmailLabel') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <span class="form-control disabled-field">{{ getSsoUserCustomerReg.userEmail }}</span>
                        </b-input-group>
                    </b-form-group>
                </div>
                <div class="row">
                    <b-form-group class="mt-1 col-12">
                        <b-input-group>
                            <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                            <b-input-group-text slot="prepend" class="col-12 pretext"><span class="pretext-span">{{ t('ssoUserPassLabel', 'ssoUserPassLabel') }}</span></b-input-group-text>
                            </b-input-group-prepend>
                            <span class="form-control disabled-field">{{ t('ssoUsedPassText', 'ssoUsedPassText') }}</span>
                        </b-input-group>
                    </b-form-group>
                </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Translation from '@/components/Translation.vue'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'ssoRegistrationSuccess',
  data() {
      return {
          userPassword: '',
          customerRef: '',
          userEmail: ''
      }
  },
  methods: {
      changeBackgroud(){
        document.body.style.backgroundImage = "url("+this.$store.getters.allTemplateDetails.loginBackgroundImage+"),  linear-gradient(to top, #00c6fb 0%, #005bea 100%)"
      }
  },
  components: {
      Translation,
      ResponseInfo
  },
  computed: {
      ...mapGetters(['allTemplateDetails', 'getSpinner', 'getSsoUserCustomerReg'])
  },
  created(){
      this.changeBackgroud()
      if(!this.getSsoUserCustomerReg || Object.entries(this.getSsoUserCustomerReg).length === 0) {
          this.$router.push('/')
      } else {
          this.customerRef = this.getSsoUserCustomerReg.customerRef
          this.userEmail = this.getSsoUserCustomerReg.userEmail
      }
  }
}
</script>

<style scoped>
    .auth-box-w form {
        padding: 20px 60px;
    }
    .auth-box-w .auth-header {
        padding-left: 60px;
        margin-bottom: 5px;
    }
    .auth-box-w .auth-header::after {
        left: 60px;
    }
    .button-w {
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .disabled-field {
        background-color: rgb(233, 236, 239);
    }
</style>
